import React, { useCallback, useEffect, useState } from 'react';
import { connection, useConnection } from '../offline/connection';

// Settings > "Faster pages" (this device): the device's own switch for local-first reads, i.e. answering a few settings and live
// reads (table occupancy, the orders list) from what this device holds instead of waiting for the server. It only does anything
// when the restaurant switch (POS setting "Faster pages (local-first reads)") is on too. Shown only where an offline engine exists.

export default function LocalFirstCard() {
  const { engine } = useConnection();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  const load = useCallback(async () => {
    const r = await connection.call('GET', 'status');
    setStatus(r && r.localFirst && r.localFirst.available ? r.localFirst : null);
  }, []);

  // The restaurant switch reaches the engine with the settings list, which can arrive after this card has mounted, so look again now and then.
  useEffect(() => {
    if (!engine) return undefined;
    load();
    const timer = window.setInterval(load, 5000);
    return () => window.clearInterval(timer);
  }, [engine, load]);

  if (!engine || !status) return null;

  const toggle = async (e) => {
    const enabled = e.target.checked;
    setBusy(true);
    setFailed(false);
    const r = await connection.call('POST', 'local-first', { enabled });
    if (r && r.ok && r.localFirst) setStatus(r.localFirst);
    else setFailed(true);
    setBusy(false);
  };

  return (
    <div className="cardStyle mb-4">
      <div className="cardBody d-flex align-items-start justify-content-between gap-3">
        <div>
          <h5 className="mb-1">Faster pages (this device)</h5>
          <p className="mb-1" style={{ opacity: 0.7, fontSize: 13 }}>
            Shows table occupancy, the orders list and a few settings from what this device already holds while it checks with the
            server in the background. Turn it off to ask the server every time. This device only.
          </p>
          <p className="mb-0" style={{ fontSize: 13 }} data-testid="local-first-state">
            {failed
              ? 'The change did not go through. Try again.'
              : status.lab
                ? status.device
                  ? 'In use on this device (test build: the restaurant switch is assumed on).'
                  : 'Off on this device (test build).'
              : !status.restaurant
                ? 'Not in use yet: the restaurant switch (Faster pages) is off.'
                : status.device
                  ? 'In use on this device.'
                  : 'Off on this device.'}
          </p>
        </div>
        <div className="form-check form-switch mb-0 flex-shrink-0">
          <input className="form-check-input" type="checkbox" role="switch" aria-label="Faster pages on this device" checked={!!status.device} disabled={busy} onChange={toggle} />
        </div>
      </div>
    </div>
  );
}
